import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculationFormComponent } from '@client/shared/components/calculation-form/calculation-form.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@shared/material/material.module';

@NgModule({
  declarations: [
    CalculationFormComponent
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ReactiveFormsModule,
    MaterialModule,
    FormsModule
  ],
  exports: [
    CalculationFormComponent
  ],
})
export class CalculationFormModule {
}
